// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__iMr2i","list_nav":"Nav_list_nav__uEKQJ","tit":"Nav_tit__4QJmp"};